var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.693359,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14300_49291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9379 21.8181H9.2168V13.0554H11.9379V21.8181ZM10.5759 11.8601C9.70576 11.8601 9 11.1394 9 10.2692C9 9.85129 9.16603 9.45046 9.46156 9.15492C9.7571 8.85939 10.1579 8.69336 10.5759 8.69336C10.9938 8.69336 11.3947 8.85939 11.6902 9.15492C11.9857 9.45046 12.1518 9.85129 12.1518 10.2692C12.1518 11.1394 11.4457 11.8601 10.5759 11.8601ZM22.1221 21.8181H19.4068V17.5524C19.4068 16.5358 19.3863 15.2321 17.9921 15.2321C16.5773 15.2321 16.3605 16.3366 16.3605 17.4792V21.8181H13.6424V13.0554H16.2521V14.2507H16.2902C16.6535 13.5622 17.5409 12.8356 18.8648 12.8356C21.6187 12.8356 22.125 14.6491 22.125 17.0046V21.8181H22.1221Z",
    fill: "#143860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14300_49291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.125,
    height: 15,
    fill: "white",
    transform: "translate(9 8.69336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCircle);
export default __webpack_public_path__ + "static/media/linkedin-circle.9987142837c05af6e20872deaf1f6f68.svg";
export { ForwardRef as ReactComponent };